import type { Component, Entity2D } from '../../odie';
import { TvBlockProps } from '../defs/block';
import { TvBlockView } from '../views/blocks/TvBlockView';

export type TvBlockComponentOptions = {
  props: TvBlockProps;
};

export class TvBlockComponent implements Component {
  public static readonly NAME = 'blockTv';
  public entity!: Entity2D;
  public view!: TvBlockView;

  public init(options: TvBlockComponentOptions): void {
    this.view = new TvBlockView(options.props);
  }
}
